/**
 * @generated SignedSource<<25d0b9e8d55f92f227cd7fb35f0857db>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AgentPoolPageMoveAgentToAgentPoolMutation$variables = {
  agentPoolRawId: string;
  agentRawId: string;
};
export type AgentPoolPageMoveAgentToAgentPoolMutation$data = {
  readonly moveAgentToAgentPool: {
    readonly targetAgentPool: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type AgentPoolPageMoveAgentToAgentPoolMutation = {
  response: AgentPoolPageMoveAgentToAgentPoolMutation$data;
  variables: AgentPoolPageMoveAgentToAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentPoolRawId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentRawId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentRawId",
            "variableName": "agentRawId"
          },
          {
            "kind": "Variable",
            "name": "targetAgentPoolRawId",
            "variableName": "agentPoolRawId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MoveAgentToAgentPoolPayload",
    "kind": "LinkedField",
    "name": "moveAgentToAgentPool",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgentPool",
        "kind": "LinkedField",
        "name": "targetAgentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPoolPageMoveAgentToAgentPoolMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AgentPoolPageMoveAgentToAgentPoolMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "f122e5c4722562c5eb69c00e754ef317",
    "id": null,
    "metadata": {},
    "name": "AgentPoolPageMoveAgentToAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AgentPoolPageMoveAgentToAgentPoolMutation(\n  $agentRawId: ID!\n  $agentPoolRawId: ID!\n) {\n  moveAgentToAgentPool(input: {agentRawId: $agentRawId, targetAgentPoolRawId: $agentPoolRawId}) {\n    targetAgentPool {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2254ce859ca1f1d2450c7f9158492efe";

export default node;
